import { render } from "./GradeTasks.vue?vue&type=template&id=81f191a8&scoped=true&ts=true&lang=pug"
import script from "./GradeTasks.vue?vue&type=script&lang=ts"
export * from "./GradeTasks.vue?vue&type=script&lang=ts"

import "./GradeTasks.vue?vue&type=style&index=0&id=81f191a8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81f191a8"]])

export default __exports__